const WHATSAPP_PHONE_NUMBER = '5492616558544';

// Abre WhatsApp con el numero de la empresa y el mensaje precargado
export function openWhatsApp(message) {
  const url = `https://wa.me/${WHATSAPP_PHONE_NUMBER}?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank');
}
